import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import SectorsHero from "../sections/sectors/SectorsHero";
import SectorResidential from "../sections/sectors/SectorResidential";
import SectorCommercial from "../sections/sectors/SectorCommercial";
import SectorIndustrial from "../sections/sectors/SectorIndustrial";
import SectorInstitutional from "../sections/sectors/SectorInstitutional";
import SectorsClosing from "../sections/sectors/SectorsClosing";

const SectorsPage = () => (
    <div className="min-h-screen bg-ink text-white">
        <Seo
            title="Building Sectors | BuildEase"
            description="BuildEase focuses on residential construction projects under 500 m² today, with a considered long-term vision across commercial, industrial and institutional building sectors."
        />
        <Navbar />
        <main>
            <SectorsHero />
            <SectorResidential />
            <SectorCommercial />
            <SectorIndustrial />
            <SectorInstitutional />
            <SectorsClosing />
        </main>
        <Footer />
    </div>
);

export default SectorsPage;
